import React from "react";
import { motion } from "framer-motion";
import { FaJava, FaReact, FaJs } from "react-icons/fa";
import { SiCplusplus, SiFlutter, SiDart } from "react-icons/si";

// Import gambar lokal
import project1 from "../assets/1.jpg";
import project2 from "../assets/2.jpg";
import emptyImg from "../assets/empty.png";

const dummyProjects = [
  {
    id: 1,
    title: "Resistor Finder",
    description: "Resistor Finder using C++ logic.",
    image: project1,
    download: "https://github.com/BlackSkull457/app/releases/tag/android",
    tech: [
      <SiCplusplus title="C++" />,
      <SiDart title="Dart" />,
      <SiFlutter title="Flutter" />,
    ],
  },
  {
    id: 2,
    title: "Ar Nusantara",
    description:
      "Augmented Reality for Indonesian History with interactive feature.",
    image: project2,
    download: "#",
    tech: [<SiFlutter title="Flutter" />, <SiCplusplus title="C++" />],
  },
  {
    id: 3,
    title: "COMING SOON",
    description: "COMING SOON",
    image: emptyImg,
    download: "#",
    tech: [],
  },
];

const ProjectsSection = ({ onProjectClick }) => (
  <section className="relative text-white py-16 px-8 bg-transparent">
    <h2 className="text-3xl font-bold text-center mb-12 text-indigo-400 drop-shadow-md">
      My Projects
    </h2>

    <div className="grid md:grid-cols-3 gap-8">
      {dummyProjects.map((project) => (
        <motion.div
          key={project.id}
          whileHover={{ scale: 1.05 }}
          className="rounded-2xl overflow-hidden shadow-lg cursor-pointer
                     bg-transparent border border-transparent
                     transition-all duration-300"
          onClick={() => onProjectClick(project)}
        >
          <img
            src={project.image}
            alt={project.title}
            className="w-full h-48 object-cover rounded-t-2xl"
          />
          <div className="p-4 bg-transparent">
            <h3 className="text-xl font-semibold mb-2">{project.title}</h3>
            <p className="text-sm text-gray-200 mb-3">{project.description}</p>

            {/* Tech stack icons */}
            {project.tech.length > 0 && (
              <div className="flex gap-3 text-xl text-gray-300">
                {project.tech.map((icon, index) => (
                  <div
                    key={index}
                    className="hover:text-indigo-400 transition-colors duration-300"
                  >
                    {icon}
                  </div>
                ))}
              </div>
            )}
          </div>
        </motion.div>
      ))}
    </div>
  </section>
);

export default ProjectsSection;
